import {dataLayerPush} from "JQueryScripts/data-layer-handlers/data-layer-push";
import {obtainPlan} from "JQueryScripts/data-layer-handlers/plan-obtainer";

export const pushEventAddPaymentInfo = async (isPerson, type, planType) => {
    const item = await obtainPlan(planType, type, 'add_payment_info');
    item['ecommerce']['payment_type'] = isPerson ? 'Person' : 'Company';

    dataLayerPush(item);
};